export default __webpack_public_path__ + "static/media/Pretendard-Bold.subset.12541844.woff2";